import script from "./InterviewView.vue?vue&type=script&setup=true&lang=js"
export * from "./InterviewView.vue?vue&type=script&setup=true&lang=js"

import "./InterviewView.vue?vue&type=style&index=0&id=dbae33c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbae33c2"]])

export default __exports__